<template>
<transition name="fade">
	<b-modal
		id="modal-form"
		centered
		title="Add Payroll"
		header-bg-variant="dark"
	>

	<!-- Start Form Fields -->
	<b-row>
      <b-col>
        <b-form-group
          label="Payroll Type"
        >
          <b-form-select
            value-field="PayrollTypeID"
            text-field="PayrollTypeName"
						:options="[
							{
								PayrollTypeID: 0,
								PayrollTypeName: 'Select Payroll Type',
								disabled: true
							},
							...payroll_types
						]"
						v-model="form.PayrollTypeID"
          />
        </b-form-group>
      </b-col>
    </b-row>

	<b-row>
      <b-col>
        <b-form-group
          label="Client"
        >
          <b-form-select
            value-field="ClientID"
            text-field="ClientName"
						:options="[
							{
								ClientID: 0,
								ClientName: 'Select Client',
								disabled: true
							},
							...payroll_clients
						]"
						v-model="form.ClientID"
						@input="branchOptions(form.ClientID)"
          />
        </b-form-group>
      </b-col>
    </b-row>

	<b-row>
      <b-col>
        <b-form-group
          label="Branch"
        >
          <b-form-select
            value-field="ClientBranchID"
            text-field="BranchName"
						:options="[
							{
								ClientBranchID: 0,
								BranchName: 'All Branches',
							},
							...payroll_branches
						]"
						v-model="form.ClientBranchID"
          />
        </b-form-group>
      </b-col>
    </b-row>

		<b-row>
        <b-col>
          <b-form-group
            id="input-group-1"
            label="Year:"
            label-for="input-1"
          >
            <b-form-select
              value-field="YearID"
              text-field="CalendarYear"
							:options="[
								{
									YearID: 0,
									CalendarYear: 'Select Year',
									disabled: true
								},
								...yearOptions
							]"
							v-model="form.YearID"
            />
          </b-form-group>
        </b-col>
      </b-row>

				<b-row>
            <b-col>
              <b-form-group label="Month">
                <b-form-select
                  value-field="id"
                  text-field="label"
                  :options="[
                    { id: 0, label: 'Please select Month', disabled: true },
                    { id: 1, label: 'January' },
                    { id: 2, label: 'February' },
                    { id: 3, label: 'March' },
                    { id: 4, label: 'April' },
                    { id: 5, label: 'May' },
                    { id: 6, label: 'June' },
                    { id: 7, label: 'July' },
                    { id: 8, label: 'August' },
                    { id: 9, label: 'September' },
                    { id: 10, label: 'October' },
                    { id: 11, label: 'November' },
                    { id: 12, label: 'December' },
                  ]"
									v-model="form.Month"
                required >
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

						<b-row>
        		<b-col>
		          <b-form-group
		            id="input-group-1"
		            label="Period"
		            label-for="input-1"
		          >
		            <b-form-input
		              type="number"
									v-model="form.Period"
		            />
		          </b-form-group>
		        </b-col>
		      </b-row>

					<b-row>
        		<b-col>
		          <b-form-group
		            id="input-group-1"
		            label="From"
		            label-for="input-1"
		          >
		            <b-form-input
		              type="date"
									v-model="form.PayrollStartDate"
		            />
		          </b-form-group>
		        </b-col>
		      </b-row>

					<b-row>
        		<b-col>
		          <b-form-group
		            id="input-group-1"
		            label="To"
		            label-for="input-1"
		          >
		            <b-form-input
		              type="date"
									v-model="form.PayrollEndDate"
		            />
		          </b-form-group>
		        </b-col>
		      </b-row>

					<b-row>
        		<b-col>
		          <b-form-group
		            id="input-group-1"
		            label="Transaction Date"
		            label-for="input-1"
		          >
		            <b-form-input
		              type="date"
									v-model="form.TransactionDate"
		            />
		          </b-form-group>
		        </b-col>
		      </b-row>

					<b-row>
		        <b-col>
		          <b-form-group label="Description">
		            <b-form-textarea
		              id="textarea"
		              rows="3"
		              max-rows="6"
									v-model="form.Description"
		            ></b-form-textarea>
		          </b-form-group>
		        </b-col>
		      </b-row>

		
<!-- End Form Fields -->

<!-- Start Footer Actions -->
		<template v-slot:modal-footer="{ ok, cancel }">
			<b-button
				size="sm"
				variant="warning"
				@click="save"
				v-if="!editMode"
				><i class="fa fa-check"></i>
				Submit
			</b-button>

			<b-button size="sm" variant="warning" @click="update" v-else>
				Update
			</b-button>

			<b-button size="sm" variant="danger" @click="cancel()">
				Close
			</b-button>
		</template> 

<!-- End of Footer Actions -->

	</b-modal>
</transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from 'axios';

const initFormData = {
	EmployeeCode: "",
	PayrollCutOffID: 0,
	PayrollTypeID: 0,
	ClientID: 0,
	YearID: 0,
	Month: 0,
	Period: "",
	PayrollStartDate: "",
	PayrollEndDate: "",
	TransactionDate: "",
	Description: "",
	ClientBranchID: 0,
};

export default {
	data(){
		return {
			form: Object.assign({}, initFormData),
			editMode: false,
		}
	},
	methods:{
		...mapActions({
				yearOptions: 'getCalendarYears',
				clientOptions: 'getPayrollClients',
				payrollTypeOptions: 'getPayrollTypesDropdown',
				store: 'savePayroll',
				updateRecord: 'updatePayroll',
				getErrors: "getErrors",
				getBranchOptions: 'getClientBranches',
		}),
		create(){
			this.resetForm();
			this.$bvModal.show("modal-form");
		},
		edit(data){
			this.editMode = true;
			this.form = data.item;
			this.form.PayrollEndDate = (data.item.PayrollEndDate).substring(0,10);
			this.form.PayrollStartDate = (data.item.PayrollStartDate).substring(0,10);
			this.form.TransactionDate = (data.item.TransactionDate).substring(0,10);
			this.branchOptions(this.form.ClientID);

			this.$bvModal.show("modal-form");
		},
		save(){
			if(this.form.PayrollTypeID == 0 || this.form.ClientID == 0 || this.form.YearID == 0 || this.form.Month == 0){
				this.$swal({icon:"error", text: "Please check all required fields"});
			}
			else {
				this.store(this.form)	
					.then(response => {
						this.$bvModal.hide("modal-form");
						this.$swal({...this.response.success });
					})
					.catch(errors =>{
						this.getErrors(errors);
						this.$swal({...this.response.error, text: this.errors  });
					});	
			}
		},
		update(){
			this.updateRecord(this.form)	
				.then(response => {
					this.$bvModal.hide("modal-form");
					this.$swal({...this.response.success });
				})
				.catch(errors =>{
					this.getErrors(errors);
					this.$swal({...this.response.error, text: this.errors  });
				});
		},
		resetForm() {
			this.editMode = false;
			this.form = Object.assign({}, initFormData);
		},
		branchOptions(ClientID){
			this.getBranchOptions(ClientID).then(res => {
				this.form.ClientBranchID = 0;
			});
		},
	},
	computed: {
		...mapGetters(['errors','response','payroll_types','payroll_clients', 'payroll_branches'])
	},
	created(){
		this.payrollTypeOptions();
		this.clientOptions();
		this.yearOptions()
			.then(response => {
				this.yearOptions = response;
			})
	}
}
</script>	